/* eslint-disable */
import { CommonGet, CommonPost } from '../helpers/HttpClient';
import TokenDecoder from '../helpers/TokenDecoder';

export default {
    getPermissionsByScreen
};

async function getPermissionsByScreen(screenCode) {
    const response = await CommonGet('/api/Permission/GetPermissionsByRoleAndScreen', 'roleID=' + TokenDecoder.getRoleIDFromToken() + '&screenCode=' + screenCode);
    return response.data;
}
